export enum TabKeyEnum {
    system = 'system',
    solution = 'solution',
    generator = 'generator',
}

export type SITE = 'uk' | 'de' | 'fr' | 'it' | 'es' | 'eu' | 'ph' | 'nl';

type TabData = {
    [site in SITE]: {
        [key in TabKeyEnum]: {
            title: string;
            desc: string;
            pcImg?: string;
            padImg?: string;
        };
    };
};
export const EU2_PAGE_TAB_DATA: TabData = {
    de: {
        system: {
            title: 'Balkonkraftwerk für Einsteiger',
            desc: 'Kombinieren Sie den Mikro-Wechselrichter EcoFlow PowerStream mit EcoFlow DELTA 3/DELTA 3 Plus zu einem Balkonkraftwerk für Einsteiger, das Tag und Nacht Sonnenenergie nutzt und Ihre Energiekosten senkt.',

            pcImg: 'https://websiteoss.ecoflow.com/upload/image/1731489296605/eu-0.jpg',
            padImg: 'https://websiteoss.ecoflow.com/upload/image/1731489297056/eu-h5-0.jpg',
        },
        solution: {
            title: 'Energieversorgung für unterwegs',
            desc: 'Mit dem EcoFlow 800 W Batterieladegerät und EcoFlow DELTA 3/DELTA 3 Plus sind Sie auch unterwegs immer zuverlässig mit Energie versorgt. Erleben Sie smartes, effizientes und schnelles Laden, wohin Sie Ihre Reise auch führt.',

            pcImg: 'https://websiteoss.ecoflow.com/upload/image/1731489296811/eu-2.jpg',
            padImg: 'https://websiteoss.ecoflow.com/upload/image/1731489297332/eu-h5-2.jpg',
        },
        generator: {
            title: 'Solargenerator',
            desc: 'Der Solargenerator der EcoFlow DELTA 3 Serie fängt durch sein doppelseitiges Design mehr Energie ein, was durch die TOPCon-Solartechnologie noch verstärkt wird.',

            pcImg: 'https://websiteoss.ecoflow.com/upload/image/1731489297671/eu-1.jpg',
            padImg: 'https://websiteoss.ecoflow.com/upload/image/1731489297429/eu-h5-1.jpg',
        },
    },
    fr: {
        system: {
            title: 'Créez votre kit solaire et économisez',
            desc: "Associez des panneaux solaires et le micro-onduleur PowerStream à la batterie solaire DELTA 3 ou DELTA 3 Plus pour capter l'énergie directement depuis votre balcon. Profitez de votre propre énergie 24 h/24 et réduisez vos factures d'électricité.",

            pcImg: 'https://websiteoss.ecoflow.com/upload/image/1731489296605/eu-0.jpg',
            padImg: 'https://websiteoss.ecoflow.com/upload/image/1731489297056/eu-h5-0.jpg',
        },
        solution: {
            title: 'Voyagez en toute autonomie',
            desc: "Rechargez votre batterie solaire DELTA 3 ou DELTA 3 Plus rapidement pendant que vous conduisez en la connectant au Chargeur d'alternateur EcoFlow 800 W. Faites l'expérience d'une charge intelligente et efficace, où que votre voyage vous mène.",

            pcImg: 'https://websiteoss.ecoflow.com/upload/image/1731489296811/eu-2.jpg',
            padImg: 'https://websiteoss.ecoflow.com/upload/image/1731489297332/eu-h5-2.jpg',
        },
        generator: {
            title: "Captez plus d'énergie solaire",
            desc: "Connectez votre batterie solaire DELTA 3 ou DELTA 3 Plus à un panneau solaire EcoFlow pour créer un générateur solaire ultra-performant. La conception bifaciale de certains de nos modèles, associée à la technologie TOPCon, vous assure une efficacité de production d'énergie inégalée.",

            pcImg: 'https://websiteoss.ecoflow.com/upload/image/1731489297671/eu-1.jpg',
            padImg: 'https://websiteoss.ecoflow.com/upload/image/1731489297429/eu-h5-1.jpg',
        },
    },
    es: {
        system: {
            title: 'Kit solar tradicional para balcones',
            desc: 'Combine el microinversor EcoFlow PowerStream con el EcoFlow DELTA 3/DELTA 3 Plus para crear un kit solar para balcones básico y así aprovechar la energía solar día y noche y reducir las facturas de energía.',
            pcImg: 'https://websiteoss.ecoflow.com/upload/image/1731489296605/eu-0.jpg',
            padImg: 'https://websiteoss.ecoflow.com/upload/image/1731489297056/eu-h5-0.jpg',
        },
        solution: {
            title: 'Solución de energía para los viajes por carretera',
            desc: 'Mantente conectado y con energía incluso cuando vas por la carretera con el cargador mediante alternador EcoFlow de 800 W y el EcoFlow DELTA 3/DELTA 3 Plus. Disfruta de una carga inteligente, eficiente y rápida estés donde estés.',

            pcImg: 'https://websiteoss.ecoflow.com/upload/image/1731489296811/eu-2.jpg',
            padImg: 'https://websiteoss.ecoflow.com/upload/image/1731489297332/eu-h5-2.jpg',
        },
        generator: {
            title: 'Generador solar',
            desc: 'El generador solar EcoFlow DELTA Serie 3 captura más energía gracias a su diseño de doble cara, mejorado con la tecnología solar TOPCon para una generación de energía superior.',

            pcImg: 'https://websiteoss.ecoflow.com/upload/image/1731489297671/eu-1.jpg',
            padImg: 'https://websiteoss.ecoflow.com/upload/image/1731489297429/eu-h5-1.jpg',
        },
    },
    it: {
        system: {
            title: 'Fotovoltaico da balcone di livello base',
            desc: 'Associa il microinverter EcoFlow PowerStream a EcoFlow DELTA 3/DELTA 3 Plus per creare un sistema fotovoltaico da balcone di livello base in grado di sfruttare l’energia del sole giorno e notte, riducendo così le tue bollette energetiche.',

            pcImg: 'https://websiteoss.ecoflow.com/upload/image/1731489296605/eu-0.jpg',
            padImg: 'https://websiteoss.ecoflow.com/upload/image/1731489297056/eu-h5-0.jpg',
        },
        solution: {
            title: 'Soluzione di alimentazione da viaggio',
            desc: 'Non rimanere mai a corto di energia mentre sei in viaggio con il caricabatterie per alternatore EcoFlow da 800 W ed EcoFlow DELTA 3/DELTA 3 Plus. Goditi una ricarica rapida, efficiente e intelligente dovunque ti porti il tuo viaggio.',

            pcImg: 'https://websiteoss.ecoflow.com/upload/image/1731489296811/eu-2.jpg',
            padImg: 'https://websiteoss.ecoflow.com/upload/image/1731489297332/eu-h5-2.jpg',
        },
        generator: {
            title: 'Generatore solare',
            desc: 'Il generatore solare della serie EcoFlow DELTA 3 cattura più energia grazie al suo design a due lati. Inoltre, può contare sulla tecnologia solare TOPCon per una generazione di energia di livello superiore.',

            pcImg: 'https://websiteoss.ecoflow.com/upload/image/1731489297671/eu-1.jpg',
            padImg: 'https://websiteoss.ecoflow.com/upload/image/1731489297429/eu-h5-1.jpg',
        },
    },
    eu: {
        system: {
            title: 'Entry-Level Balcony Solar System',
            desc: 'Pair the EcoFlow PowerStream Microinverter with EcoFlow DELTA 3/DELTA 3 Plus to create an entry-level balcony solar system that harnesses solar energy day and night, reducing your energy bills.',
            pcImg: 'https://websiteoss.ecoflow.com/upload/image/1731489296605/eu-0.jpg',
            padImg: 'https://websiteoss.ecoflow.com/upload/image/1731489297056/eu-h5-0.jpg',
        },
        solution: {
            title: 'On-the-Road Power Solution',
            desc: 'Stay powered on the road with the EcoFlow 800W Alternator Charger and EcoFlow DELTA 3/DELTA 3 Plus. Experience smart, efficient, and fast charging wherever your journey takes you.',

            pcImg: 'https://websiteoss.ecoflow.com/upload/image/1731489296811/eu-2.jpg',
            padImg: 'https://websiteoss.ecoflow.com/upload/image/1731489297332/eu-h5-2.jpg',
        },
        generator: {
            title: 'Solar Generator',
            desc: 'The EcoFlow DELTA 3 Series Solar Generator captures more energy with its dual-sided design, enhanced by TOPCon solar technology for superior energy generation.',

            pcImg: 'https://websiteoss.ecoflow.com/upload/image/1731489297671/eu-1.jpg',
            padImg: 'https://websiteoss.ecoflow.com/upload/image/1731489297429/eu-h5-1.jpg',
        },
    },
    nl: {
        system: {
            title: 'Instapmodel balkon-zonnesysteem',
            desc: 'Combine de EcoFlow PowerStream micro-omvormer met de EcoFlow DELTA 3/DELTA 3 Plus om een ​​instapmodel balkon-zonnesysteem te creëren dat dag en nacht zonne-energie benut en zo uw energierekening verlaagt.',
            pcImg: 'https://websiteoss.ecoflow.com/upload/image/1731489296605/eu-0.jpg',
            padImg: 'https://websiteoss.ecoflow.com/upload/image/1731489297056/eu-h5-0.jpg',
        },
        solution: {
            title: 'Stroomoplossing voor onderweg',
            desc: 'Blijf onderweg van stroom voorzien met de EcoFlow 800W dynamo-oplader en de EcoFlow DELTA 3/DELTA 3 Plus. Ervaar slim, efficiënt en snel opladen, waar uw reis u ook brengt.',

            pcImg: 'https://websiteoss.ecoflow.com/upload/image/1731489296811/eu-2.jpg',
            padImg: 'https://websiteoss.ecoflow.com/upload/image/1731489297332/eu-h5-2.jpg',
        },
        generator: {
            title: 'Zonnegenerator',
            desc: 'De EcoFlow DELTA 3-serie zonnegenerator vangt meer energie op dankzij het dubbelzijdige ontwerp, aangevuld met TOPCon-zonnetechnologie voor een superieure energieopwekking.',

            pcImg: 'https://websiteoss.ecoflow.com/upload/image/1731489297671/eu-1.jpg',
            padImg: 'https://websiteoss.ecoflow.com/upload/image/1731489297429/eu-h5-1.jpg',
        },
    },
    ph: {
        system: {
            title: 'Entry-Level Balcony Solar System',
            desc: 'Pair the EcoFlow PowerStream Microinverter with EcoFlow DELTA 3 to create an entry-level balcony solar system that harnesses solar energy day and night, reducing your energy bills.',
            pcImg: 'https://websiteoss.ecoflow.com/upload/image/1751012109290/1.jpg',
            padImg: 'https://websiteoss.ecoflow.com/upload/image/1751012161825/1_h5.jpg',
        },
        solution: {
            title: 'On-the-Road Power Solution',
            desc: 'Stay powered on the road with the EcoFlow 800W Alternator Charger and EcoFlow DELTA 3. Experience smart, efficient, and fast charging wherever your journey takes you.',
            pcImg: 'https://websiteoss.ecoflow.com/upload/image/1751012109459/2.jpg',
            padImg: 'https://websiteoss.ecoflow.com/upload/image/1751012109617/2_h5.jpg',
        },
        generator: {
            title: 'Solar Generator',
            desc: 'The EcoFlow DELTA 3 Series Solar Generator captures more energy with its dual-sided design, enhanced by TOPCon solar technology for superior energy generation.',

            pcImg: 'https://websiteoss.ecoflow.com/upload/image/1751012169103/3.jpg',
            padImg: 'https://websiteoss.ecoflow.com/upload/image/1751012109007/3_h5.jpg',
        },
    },
    uk: {
        system: {
            title: 'Entry-Level Balcony Solar System',
            desc: 'Pair the EcoFlow PowerStream Microinverter with EcoFlow DELTA 3/DELTA 3 Plus to create an entry-level balcony solar system that harnesses solar energy day and night, reducing your energy bills.',
        },
        solution: {
            title: 'On-the-Road Power Solution',
            desc: 'Stay powered on the road with the EcoFlow 800W Alternator Charger and EcoFlow DELTA 3/DELTA 3 Plus. Experience smart, efficient, and fast charging wherever your journey takes you.',

            pcImg: 'https://websiteoss.ecoflow.com/upload/image/1731489791234/uk-2.jpg',
            padImg: 'https://websiteoss.ecoflow.com/upload/image/1731489791448/uk-h5-2.jpg',
        },
        generator: {
            title: 'Solar Generator',
            desc: 'The EcoFlow DELTA 3 Series Solar Generator captures more energy with its dual-sided design, enhanced by TOPCon solar technology for superior energy generation.',

            pcImg: 'https://websiteoss.ecoflow.com/upload/image/1731489791016/uk-1.jpg',
            padImg: 'https://websiteoss.ecoflow.com/upload/image/1731489791710/uk-h5-1.jpg',
        },
    },
};

export const EU2_PAGE_DATA: {
    [site in SITE]: {
        linkText: string;
        title: string;
        disableLinkText?: string;
    };
} = {
    de: {
        title: 'Verbesserte Nutzung einer tragbaren 1 kWh Solarbatterie',
        linkText: 'Mehr erfahren>',
        disableLinkText: 'in Kürze verfügbar',
    },
    fr: {
        title: "Utilisation polyvalente d'une batterie solaire portable de 1 kWh",
        linkText: 'En savoir plus>',
        disableLinkText: 'bientôt disponible',
    },
    es: {
        title: 'Uso avanzado de la batería solar portátil de 1 kWh',
        linkText: 'Más información>',
        disableLinkText: 'próximamente',
    },
    it: {
        title: 'Utilizzo avanzato di una batteria solare portatile da 1 kWh',
        linkText: 'Scopri di più>',
        disableLinkText: 'Disponibile a breve',
    },
    eu: {
        title: 'Advanced Usage of 1kWh Portable Solar Battery',
        linkText: 'Learn More>',
        disableLinkText: 'Coming Soon',
    },
    nl: {
        title: 'Geavanceerd gebruik van een draagbare zonnebatterij van 1 kWh',
        linkText: 'Meer informatie >',
        disableLinkText: 'Binnenkort verkrijgbaar',
    },
    ph: {
        title: 'Advanced Usage of 1kWh Portable Solar Battery',
        linkText: 'Learn More>',
        disableLinkText: 'Coming Soon',
    },
    uk: {
        title: 'Advanced Usage of 1kWh Portable Solar Battery',
        linkText: 'Learn More>',
        disableLinkText: 'Coming Soon',
    },
};
